import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "components/Switch/Switch";
// import { Input } from "components/Form";
// import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import { RemoveRedEye } from "@mui/icons-material";
import toast from "react-hot-toast";
import {
  getUserRoledropdownList,
  getViewUsers,
  UpdateStatusofUser,
} from "services/usermanagement";
import ModalBox from "components/modal/ModalBox";

export default function ManageUser() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [record, setRecord] = useState([{}]);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [allRoles, setAllRoles] = useState([]);

  const [statusModal, setStatusModal] = useState(false);

  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ****************************** Fetch All Roles *****************************************



  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getViewUsers({
        page: activePage,
        search: search,
        limit: limit,
      });
      // console.log(res)
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.users;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total>limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit)+1);
        }
        setSelectedId("")
      } else {
        toast.error(res.message);
        setSelectedId("")
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);


  // ************************************* Update Status ***************************************
  const handleUserStatus = async () => {
    showLoader();
    setSubmitLoading(true);
    try {
      const res = await UpdateStatusofUser({
        UserID: selectedId,
      });
      hideLoader();
      setSubmitLoading(false);
      if (res.code === 200) {
        setSubmitLoading(false);
        setStatusModal(false);
        fetchRecord();
        toast.success(res.message);
      } else {
        setSubmitLoading(false);
        setStatusModal(false);
        fetchRecord();
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
    setSubmitLoading(false);
  };
  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap " style={{ width: "60%" }}>
                <div className="SearchBox w-100">
                  <div className="div_wrap mx-1" style={{ width: "40%" }}></div>
                  <div className="div_wrap mx-1" style={{ width: "40%" }}>
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  {/* <div className="div_wrap " style={{ width: "40%" }}>
                  <select
                      className="form-control"
                      onChange={({ target }) => setSelectedId(target.value)}
                      value={selectedId}
                      // name={"selectedRole"}
                    >
                      <option id="blockStatus" value="">
                        Select Type
                      </option>

                      {allRoles &&
                        allRoles.map(({ label, value }) => {
                          return (
                            <option value={value} key={value}>
                              {label}
                            </option>
                          );
                        })}
                    </select>
                  </div> */}
                  <div>
                    <Button to="add-user">Add&nbsp;User</Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">Manage Users</h4>
            </div>
            {/* <hr className="border border-danger" /> */}
            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th style={{ borderRight: "1px solid #fff" }}>S.No</th>
                    {/* <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      District Name
                    </th> */}
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      Name
                    </th>
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      Mobile
                    </th>
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      Email
                    </th>
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      State
                    </th>
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      District
                    </th>
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                    >
                      Status
                    </th>
                    {/* <th className="text-center">Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          UserID,
                          Name,
                          DistrictName,
                          UserTypeName,
                          UserTypeID,
                          FirstName,
                          LastName,
                          EmailID,
                          UserName,
                          Mobile,
                          Phone,
                          Address,
                          City,
                          State,
                          ZipCode,
                          District,
                          Status,
                          Role,
                          EmployeeCode,
                          Description,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td style={{ width: "50px" }}>
                            {++i + (activePage - 1) * limit}
                          </td>
                          {/* <td>{DistrictName}</td> */}
                          <td>
                            {Name}
                          </td>
                          <td>{Mobile}</td>
                          <td>{EmailID}</td>
                          <td>{State}</td>
                          <td>{District}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <Switch
                                checked={Status}
                                onChange={() => {
                                  setSelectedId(UserID);
                                  setStatusModal(true);
                                }}
                              />
                            </div>
                          </td>
                          {/* <td style={{ width: "100px" }}>
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`view-user/${UserID}`);
                                  }}
                                >
                                  <RemoveRedEye sx={{ color: "#4971B2" }} />
                                </IconButton>

                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    setSelectedId(1);
                                    navigate(`edit-user/${UserID}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td> */}
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* ***********************************  Update Status Of User ****************************************** */}
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={"Change Status"}
        description={"Are you sure? You want to change status"}
        customizedFooter={
          <>
            <Button onClick={handleUserStatus} {...submitButtonElement}>
              Yes
            </Button>
          </>
        }
        // Close={true}
        // custom={false}
      />
    </>
  );
}
